import pinia from '@/pinia'
import { useThemeStore } from '@/pinia/stores/themeStore'

export default {
  computed: {
    themeStore() {
      return useThemeStore(pinia)
    },
    themeMode() {
      return this.themeStore.themeMode
    },
    vuetifyPreset() {
      return this.themeStore.vuetifyPreset
    },
  },
  methods: {
    changeThemeDarkMode(isDark) {
      this.themeStore.changeThemeDarkMode(isDark)
    },
    changeThemeLayout(layout) {
      this.themeStore.changeThemeLayout(layout)
    },
    changeThemeRtl() {
      this.themeStore.changeThemeRtl()
    },
    changeThemeLoadingState(payload) {
      this.themeStore.changeThemeLoadingState(payload)
    },
    changeVerticalSidebarDrawer() {
      this.themeStore.changeVerticalSidebarDrawer()
    },
    changeVerticalSaasSidebarDrawer() {
      this.themeStore.changeVerticalSaasSidebarDrawer()
    },
    changeVerticalSidebarDrawerColor(color) {
      this.themeStore.changeVerticalSidebarDrawerColor(color)
    },
    changeAppBarColor(color) {
      this.themeStore.changeAppBarColor(color)
    },
    changeCompactVerticalSidebarDrawer() {
      this.themeStore.changeCompactVerticalSidebarDrawer()
    },
    changeVerticalSidebarMini() {
      this.themeStore.changeVerticalSidebarMini()
    },
  },
}

